export default __webpack_public_path__ + "static/media/linet_logo_white.45c1f6c1.png";